import { enumify, Enumify, EnumValue } from '@mews/enumify';
import {
    BreakpointRangeName,
    BreakpointRangeProps,
    BreakpointRangeValue,
    BreakpointRange as MewsBreakpointRange,
} from '@optimus-web/core';

export type BreakpointEnumItem = EnumValue<BreakpointRangeName, BreakpointRangeValue>;

export type WithBreakpointRange = BreakpointRangeProps<BreakpointEnumItem>;

function BreakpointRange() {}

enumify<BreakpointRangeName, BreakpointRangeValue>(BreakpointRange, 'BreakpointRange', MewsBreakpointRange);

export default BreakpointRange as unknown as Enumify<BreakpointRangeName, BreakpointRangeValue>;
